import { render, staticRenderFns } from "./AdicionarHistoricoTempo.vue?vue&type=template&id=0d069518"
import script from "./AdicionarHistoricoTempo.vue?vue&type=script&lang=js"
export * from "./AdicionarHistoricoTempo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports